import { formatISO } from 'date-fns';

// A Date's local calendar day as 'yyyy-MM-dd' — the shape of every `local_date`, and of
// the API's date params. Local, never `toISOString()`: that is the UTC day. A machine key,
// so it takes no locale, unlike every date a reader sees (see "i18n" in apps/web/CLAUDE.md).
export const toDateKey = (date) => formatISO(date, { representation: 'date' });

// The viewer's calendar day as a date key — what every `local_date` is compared against,
// as a string.
export const getTodayKey = () => toDateKey(new Date());
